// Copyright (c) 2016 Deere & Company

import '../../../../shared/components/labeled-string/index.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';

function handleCityChange(event) {

    this('city', event.target.value);

}

const City = ({onItemChange, statusChangeRequest}) => {

    const status = statusChangeRequest.newStatus.key;

    return (
        <div className='labeled-string'>
            <span className='data-label'>
                <sup>{status === 'STL1' || status === 'STLP' ? '*' : null}</sup> <FormattedMessage id='CITY'/>
            </span>
            <input
                maxLength='24'
                onChange={onItemChange::handleCityChange}
                type='text'
            />
        </div>
    );

};

City.displayName = 'City';
City.propTypes = {
    onItemChange: PropTypes.func.isRequired,
    statusChangeRequest: PropTypes.instanceOf(StatusChange).isRequired
};

export default City;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/input-fields/city.js